var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('v-card',{staticClass:"pa-10 text-center",attrs:{"light":"","rounded":"lg"}},[_vm._v(" "+_vm._s(_vm.getText())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }